import ICreatedAgentActivation from './ICreatedAgentActivation';

/**
 * What happened to the new agent's way in, from the creator's point of view.
 *
 * - 'email-sent'     the activation email went out; the agent already has the link.
 * - 'show-link'      no email, but we hold the link and must hand it over.
 * - 'no-way-in'      neither. The agent exists but cannot log in, and nobody has been told.
 */
export type ActivationOutcome = 'email-sent' | 'show-link' | 'no-way-in';

/**
 * Classifies a create response.
 *
 * The distinction that matters is between "no link to show because the email carried it" and
 * "no link because creating it failed" - IdentityServer answers 200 in both cases, since failing
 * the request after the user row exists would only report "nothing was created" while leaving an
 * orphan behind.
 *
 * Showing the link when the email already carried it is avoided on purpose: it spreads a
 * credential-equivalent URL further than necessary.
 */
export function getActivationOutcome(
    result: ICreatedAgentActivation | null | undefined
): ActivationOutcome {
    if (!result) {
        return 'no-way-in';
    }

    if (result.activationEmailSent) {
        return 'email-sent';
    }

    if (result.passwordLink) {
        return 'show-link';
    }

    return 'no-way-in';
}

export default getActivationOutcome;
